<template>
  <div class="bg-white box-shadow-main rounded-6 border overflow-hidden">
    <div class="p-4 bg-top-black">
      <p class="mb-0 body-2-2 font-semibold text-16 text-white">
        Booking Summary
      </p>
      <p class="mb-0 body-2-2 font-bold text-20 text-white">
        {{ getMerchant.name }}
      </p>
    </div>

    <div class="px-4 pt-4 border-b-semi-grey">
      <ProductCart page="CART-ADDITIONAL" :hideRemove="disabledForm" />
    </div>

    <div class="p-4 border-b-semi-grey">
      <PromoCode />
    </div>
    
    <div class="w-100 p-4 bg-light">
      <div class="mb-3 pb-3 border-b-form-dashed-2">
        <div class="row">
          <div class="col-6">
            <p class="mb-0 body-2">Subtotal(Incl. Tax)</p>
          </div>
          <div class="col-6 text-right">
            <p class="text-14 font-lato mb-0">
              {{ $formatCurrency(subTotalPrice + taxAndServicePrice) }}
            </p>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-6">
            <p class="mb-0 body-2">Discount</p>
          </div>
          <div class="col-6 text-right">
            <p
              class="text-14 font-lato mb-0"
              :class="{
                'text-success': promotionPrice > 0,
              }">
              {{ promotionPrice > 0 ? '-' : ''
              }}{{ $formatCurrency(promotionPrice) }}
            </p>
          </div>
        </div>
        <div class="row mt-2" v-if="paymentSurcharge > 0">
          <div class="col-6">
            <p class="mb-0 body-2">Payment Surcharge</p>
          </div>
          <div class="col-6 text-right">
            <p class="text-14 font-lato mb-0">
              {{ $formatCurrency(paymentSurcharge) }}
            </p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-4">
          <p class="mb-0 sub-heading-1-2">Total</p>
        </div>
        <div class="col-8 text-right">
          <p class="text-18 font-lato mb-0">
            {{ $formatCurrency(totalPrice + paymentSurcharge) }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ProductCart from './ProductCart.vue';
import PromoCode from './PromoCode.vue';

export default {
  props: {
    paymentSurcharge: {
      type: Number,
      default: 0,
    },
    disabledForm: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ProductCart,
    PromoCode
  },
  computed: {
    ...mapGetters([
      'getMerchant',

      'getActivityTrxSubTotal',
      'getActivityTrxTaxService',
      'getActivityTrxPromotion',
      'getActivityTrxTotal',

      'getOutletTrxSubTotal',
      'getOutletTrxTaxService',
      'getOutletTrxPromotion',
      'getOutletTrxTotal',

      'getVoucherOrderSubTotal',
      'getVoucherOrderTotalPromo',
      'getVoucherOrderTotal',
    ]),
    subTotalPrice() {
      return (
        Number(this.getActivityTrxSubTotal) +
        Number(this.getOutletTrxSubTotal) +
        Number(this.getVoucherOrderSubTotal)
      );
    },
    promotionPrice() {
      return (
        Number(this.getActivityTrxPromotion) +
        Number(this.getOutletTrxPromotion) +
        Number(this.getVoucherOrderTotalPromo)
      );
    },
    taxAndServicePrice() {
      return (
        Number(this.getActivityTrxTaxService) +
        Number(this.getOutletTrxTaxService)
      );
    },
    totalPrice() {
      return (
        Number(this.getActivityTrxTotal) +
        Number(this.getOutletTrxTotal) +
        Number(this.getVoucherOrderTotal)
      );
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/hotel/be/additionalService/CartPreview.vue